"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlertProps = exports.BookingInfoOfReservation = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _moment = _interopRequireDefault(require("moment/moment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Alert = _interopRequireWildcard(require("../../../../../ui/Alert"));
var _localization = _interopRequireDefault(require("../../../../../../localization"));
var _selectors = require("../../store/selectors");
var _AdditionalHotelInfo = require("../AdditionalHotelInfo");
var _reservationIcon = _interopRequireDefault(require("./img/reservationIcon.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var renderDate = function renderDate(date) {
  return (0, _moment.default)(date).format('DD MMMM HH:mm');
};
var getSuccessProps = function getSuccessProps(successMsg) {
  return {
    Component: 'div',
    props: {
      children: successMsg
    }
  };
};
var getWarningProps = function getWarningProps(warningMsg) {
  return {
    Component: _Alert.default,
    props: {
      type: _Alert.TYPES.DANGER,
      children: warningMsg
    }
  };
};
var getAlertProps = exports.getAlertProps = function getAlertProps(bookingInfo, bookingQuota) {
  if (bookingInfo) {
    return bookingInfo.allow ? getSuccessProps(_localization.default.t('OFFER_DETAILS:BOOKING_IS_POSSIBLE_ALERT', {
      date: renderDate(bookingInfo.endDate)
    })) : getWarningProps(_localization.default.t('OFFER_DETAILS:BOOKING_IS_UNPOSSIBLE_ALERT'));
  }
  return bookingQuota.allow ? getSuccessProps(_localization.default.t('OFFER_DETAILS:BOOKING_QUOTA_POSSIBLE_ALERT', {
    date: renderDate(bookingQuota.endDate)
  })) : getWarningProps(_localization.default.t('OFFER_DETAILS:BOOKING_QUOTA_UNPOSSIBLE_ALERT'));
};
var BookingInfoOfReservationPure = function BookingInfoOfReservationPure(_ref) {
  var className = _ref.className;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.getBootstrapOffer),
    bookingInfo = _useSelector.bookingInfo,
    bookingQuota = _useSelector.bookingQuota;
  if (!bookingInfo && !bookingQuota) {
    return null;
  }
  var _getAlertProps = getAlertProps(bookingInfo, bookingQuota),
    Component = _getAlertProps.Component,
    props = _getAlertProps.props;
  return /*#__PURE__*/_react.default.createElement(_AdditionalHotelInfo.AdditionalHotelInfo, {
    icon: _reservationIcon.default
  }, /*#__PURE__*/_react.default.createElement(Component, _extends({
    className: className
  }, props)));
};
var BookingInfoOfReservation = exports.BookingInfoOfReservation = (0, _react.memo)(BookingInfoOfReservationPure);
BookingInfoOfReservation.propTypes = {
  className: _propTypes.default.string
};